import { render, staticRenderFns } from "./GelirGiderTurList.vue?vue&type=template&id=706573a1&scoped=true"
import script from "./GelirGiderTurList.vue?vue&type=script&lang=ts"
export * from "./GelirGiderTurList.vue?vue&type=script&lang=ts"
import style0 from "./GelirGiderTurList.vue?vue&type=style&index=0&id=706573a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706573a1",
  null
  
)

export default component.exports